import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";

import toast from "react-hot-toast";
import moment from "moment";
import { capitalCase } from "capital-case";
import { useForm, Controller } from "react-hook-form";

import DesignerDetail from "pages/ma/designer-detail";
import Prompt from "components/UpStyled/Prompt";
import qs from "query-string";

const DesignerList = () => {
  const [user, setUser] = useState();
  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const userId = urlObj?.query?.userId;

  useEffect(() => {
    if (userId) {
      retrieveUser(userId);
    } else {
      setUser({});
    }
  }, [userId, location]);

  const retrieveUser = async (userId) => {
    if (!userId) {
      return;
    }
    try {
      const {
        data: { user },
      } = await api.users.retrieve(userId);
      if (user?.id) {
        setUser(user);
      } else {
        toast.error("User not existed!");
      }
    } catch (err) {
      console.log(err);
    }
  };
  console.log(user);

  return userId ? (
    <DesignerDetail user={user} />
  ) : (
    <Card sx={{ p: 3 }}>
      <SuiTypography variant="h5" color="dark" fontWeight="bold" sx={{ minHeight: 120 }}>
        Can't find the user!
      </SuiTypography>
    </Card>
  );
};

export default DesignerList;
